import { render, staticRenderFns } from "./OrderSteps.vue?vue&type=template&id=286f8c4e&"
import script from "./OrderSteps.vue?vue&type=script&lang=js&"
export * from "./OrderSteps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports